<div class="page full-height gray-font-color font-family bodyBackground">
  <div class="header-navigation-back">
    <mat-icon data-test="back-arrow-icon" (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">{{ shipment?.shipmentID || '' }}</span>
  </div>
  <div class="full-height">
    <div class="search-container">
      <form class="summary-filters">
        <mat-form-field appearance="outline" floatLabel="auto">
          <mat-label>Search documents</mat-label>
          <mat-icon matPrefix svgIcon="magnifying-glass" data-test="search"></mat-icon>
          <input
            matInput
            type="search"
            (input)="onSearchInput(searchInput.value)"
            #searchInput
            [value]="currentSearchInput"
            [disabled]="!isContentReady"
            data-test="search-field"
            />
        </mat-form-field>
      </form>
      <button mat-stroked-button class="filter-button" data-test="filter-button" (click)="openRoleFilterSheet()" [disabled]="!isContentReady">
        <mat-icon svgIcon="filter" data-test="filter"></mat-icon>
      </button>
    </div>
    @if (isContentReady) {
      <div class="documents-grid-container">
        @if (filteredShipmentDocumentTypes?.length) {
          <div class="documents-grid">
            @for (type of filteredShipmentDocumentTypes; track type) {
              <div class="document-card-wrapper">
                <app-document-tile-box [shipment]="shipment" [document]="type"></app-document-tile-box>
              </div>
            }
          </div>
        }
        @if (!filteredShipmentDocumentTypes?.length) {
          <div class="no-document">
            No Documents Found
          </div>
        }
      </div>
    }
  </div>
</div>
